import { render, staticRenderFns } from "./SchoolManager.vue?vue&type=template&id=5132a8ff&scoped=true&"
import script from "./SchoolManager.vue?vue&type=script&lang=ts&"
export * from "./SchoolManager.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolManager.vue?vue&type=style&index=0&id=5132a8ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132a8ff",
  null
  
)

export default component.exports